/**
 * Optimizirano učitavanje dailyMetrics za tjedni prikaz (Sati.jsx).
 * Umjesto 3 pune godine, dohvaća samo mjesece koji se pojave u tjednoj mreži.
 */

import { collection, getDocs, query, where } from 'firebase/firestore';
import { getWeeksInYear } from './weekUtils';

function docsToMetrics(snapshot) {
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
}

/**
 * Mapa: godina -> Set(mjeseci) potrebnih za prikaz tjedana u kalendarskoj godini.
 */
export function getDailyMetricsMonthsByYear(calendarYear) {
  const weeks = getWeeksInYear(calendarYear);
  const byYear = new Map();
  weeks.forEach((week) => {
    week.dates.forEach(({ year, month }) => {
      if (!byYear.has(year)) byYear.set(year, new Set());
      byYear.get(year).add(month);
    });
  });
  return byYear;
}

/**
 * Firestore upiti za dailyMetrics – paralelno, bez duplikata po id.
 */
export async function fetchDailyMetricsForCalendarYear(db, calendarYear) {
  const monthsByYear = getDailyMetricsMonthsByYear(calendarYear);
  const queryPromises = [];

  for (const [year, monthsSet] of monthsByYear) {
    const months = [...monthsSet].sort((a, b) => a - b);
    if (months.length === 0) continue;

    if (months.length === 12) {
      queryPromises.push(
        getDocs(query(collection(db, 'dailyMetrics'), where('year', '==', year)))
      );
    } else {
      queryPromises.push(
        getDocs(
          query(
            collection(db, 'dailyMetrics'),
            where('year', '==', year),
            where('month', 'in', months)
          )
        )
      );
    }
  }

  const snapshots = await Promise.all(queryPromises);
  const byId = new Map();
  snapshots.forEach((snap) => {
    docsToMetrics(snap).forEach((m) => {
      if (m.id) byId.set(m.id, m);
    });
  });
  return [...byId.values()];
}
